/**
 * Csv Schema of CargaOpenlog
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {CargaOpenlog} from '@/model/resource/CargaOpenlog'

/* TODO: review generated schema */
export class CsvCargaOpenlogSchema extends Schema {
  readonly name = 'CsvCargaOpenlog'

  readonly fieldSet: FieldSet<CargaOpenlog> = {
    idCodigoPk: schema => schema.model.idCodigoPk,
    carga: schema => schema.model.carga?.$id ?? null,
    idPedido: schema => schema.model.idPedido,
  }
}
